<template>
  <div>
    <div class="row mb_20">
      <div class="col_4">
        <div class="card vlan-home-mini-stats mt_0">
          <div class="card_heading">
            <span class="mr_5">
              <svg
                fill="#000000"
                width="22px"
                height="22px"
                version="1.1"
                id="Capa_1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                viewBox="0 0 488.765 488.766"
                xml:space="preserve"
              >
                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                <g
                  id="SVGRepo_tracerCarrier"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></g>
                <g id="SVGRepo_iconCarrier">
                  <g>
                    <g>
                      <path
                        d="M406.959,87.047l0.046-0.962c0.188-3.994-1.122-7.869-3.504-10.364c-2.098-2.194-4.891-3.311-8.303-3.311h-57.341 l-0.03-2.569c-0.046-3.458-0.071-6.911-0.071-10.374c0-1.147-0.146-2.293-0.481-3.598l-0.097-0.378l0.021-0.391 c0.197-3.999-1.103-7.884-3.489-10.395c-2.097-2.204-4.896-3.323-8.317-3.323c-10.837,0-21.673-0.046-32.499-0.094l-2.539-0.01 l-0.051-2.536c-0.219-11.278-0.944-20.67-2.285-29.557c-0.863-5.692-6.865-9.095-12.183-9.095l-0.726,0.005l-0.62-0.065L223.822,0 c-3.758,0-6.863,1.409-8.98,4.088c-2.542,3.22-3.473,7.987-2.417,12.449l0.183,0.764l-0.277,0.744 c-0.576,1.549-0.873,3.087-0.873,4.575v17.514l-2.684-0.084c-11.022-0.337-22.046-0.724-33.071-1.257l-0.536-0.018 c-1.051,0-2.079,0.147-3.255,0.46l-0.343,0.091l-0.358-0.005h-0.005c-6.167,0-12.621,3.885-12.71,12.418 c-0.046,4.373-0.213,8.737-0.478,13.084l-0.147,2.438l-2.443,0.005c-18.943,0.053-39.212,0.401-59.074,2.549 c-0.678,0.071-1.274,0.239-1.879,0.401l-0.825,0.124c-6.215,0-12.428,3.832-12.428,12.401v49.139c0,2.755,0.69,5.19,2.054,7.221 l0.442,0.658v0.79c-0.021,110.512-0.411,210.279-4.992,312.123c-0.058,1.239,0.079,2.474,0.401,3.87l0.125,0.527l-0.099,0.538 c-0.62,3.402-0.074,6.511,1.543,8.766c1.455,2.036,3.75,3.3,6.797,3.757c99.894,14.817,198.458,16.026,307.71,16.036l0.011,2.601 v-2.601c7.886,0,10.471-6.012,11.212-8.592l0.167-0.578l0.406-0.447c2.026-2.234,3.053-5.078,3.053-8.47V95.672 c0-3.093-0.844-5.738-2.504-7.866L406.959,87.047z M236.177,25.834h29.097l0.111,2.476c0.168,3.364,0.265,6.733,0.29,10.103 l0.015,2.641l-9.079-0.091c-5.962-0.059-11.921-0.117-17.88-0.219l-2.554-0.048V25.834z M179.182,120.097 c0.927-7.01,1.811-23.976,2.511-37.61c0.322-6.276,0.609-11.758,0.838-15.074l0.178-2.529l2.526,0.109 c43.132,1.851,85.695,2.153,125.273,2.196h2.569l0.025,2.567c0.295,27.784,0.838,47.174,1.549,54.598l0.279,2.966l-2.976-0.119 c-22.638-0.927-45.677-1.572-67.951-2.191c-20.784-0.582-41.563-1.163-62.342-1.97l-2.849-0.109L179.182,120.097z M385.333,460.309h-2.601c-98.075-0.062-186.598-1.117-276.721-13.497l-2.341-0.32l0.099-2.366 c4.296-100.585,4.654-200.923,4.659-312.25c0-2.762-0.69-5.2-2.059-7.238l-0.437-0.655V94.737l2.407-0.178 c15.991-1.181,31.864-1.399,43.896-1.455l2.965-0.015l-0.37,2.947c-0.114,0.914-0.259,7.774-0.374,13.284 c-0.188,9.039-0.292,13.416-0.442,14.492c-0.322,2.397-0.233,4.764,0.27,7.025l0.109,0.511l-0.094,0.521 c-0.78,4.288,0.292,8.901,2.792,12.037c2.133,2.682,5.205,4.189,8.882,4.357c26.141,1.195,52.747,1.904,78.478,2.584 c25.753,0.681,52.382,1.389,78.569,2.59l0.68,0.016c7.896,0,10.08-6.307,10.659-9.021l0.198-0.957l0.781-0.589 c3.534-2.641,5.373-6.302,4.926-9.795c-0.244-1.924-0.432-9.044-0.665-18.89c-0.137-5.758-0.284-11.71-0.401-13.137l-0.243-2.823 h46.372v362.067H385.333z"
                      ></path>
                      <path
                        d="M336.594,354.788c-15.265-16.864-30.428-33.809-45.077-51.196l44.3-44.3c4.915-4.916,3.361-11.213-0.594-14.869 c-0.351-0.611-0.762-1.216-1.255-1.792c-10.811-12.604-22.516-24.361-34.251-36.102c-10.567-10.573-21.576,10.092-28.157,16.219 c-13.431,12.489-17.402,15.993-30.828,28.49c-12.396-12.492-28.472-28.927-40.225-42.033c-2.803-3.128-6.167-3.842-9.194-3.052 c-2.516-0.13-5.146,0.729-7.472,3.052l-30.549,30.549c-4.743,4.74-3.473,10.773,0.163,14.48c0.452,0.751,0.983,1.482,1.683,2.184 c13.371,13.375,25.246,30.655,38.012,44.604c-16.11,17.356-27.444,34.327-43.44,51.795c-5.814,6.358-1.856,14.696,4.134,17.286 c9.224,10.76,19.177,20.84,29.193,30.858c3.707,3.707,8.193,3.723,11.751,1.823c1.389-0.518,2.742-1.381,3.994-2.752 c15.704-17.22,32.037-33.819,48.484-50.312c13.998,16.803,28.531,33.128,43.166,49.388c3.899,4.337,8.851,4.027,12.517,1.483 c1.732-0.315,3.459-1.046,5.073-2.407c11.689-9.882,18.809-16.768,30.433-26.73c5.372-4.601,3.828-10.806-0.3-14.452 C337.731,356.251,337.239,355.504,336.594,354.788z M299.458,377.853c-14.721-16.412-29.335-32.936-43.279-50.028 c-2.879-3.52-6.441-4.129-9.603-3.037c-2.392-0.025-4.872,0.838-7.066,3.037c-16.661,16.666-33.243,33.403-49.279,50.663 c-6.162-6.23-12.152-12.624-17.971-19.18c15.882-17.031,26.921-33.718,42.609-50.922c4.456-4.896,3.141-10.959-0.416-14.686 c-0.391-0.681-0.858-1.341-1.438-1.98c-12.53-13.995-24.272-31.24-37.521-44.544l16.402-16.399 c12.708,13.814,29.706,31.004,43,44.298c14.78,14.726,53.562-50.153,59.093-44.531c6.773,6.878,13.497,13.814,19.936,21.01 l-42.137,42.138c-0.909,0.908-1.533,1.878-2.036,2.854c-2.793,3.777-3.585,9.231,0.183,13.812 c14.894,18.067,30.463,35.546,46.148,52.934C309.264,369.407,306.33,371.784,299.458,377.853z"
                      ></path>
                    </g>
                  </g>
                </g>
              </svg>
            </span>
            Unresolved
          </div>
          <div class="card_body">
            <div class="mini-stats-content">
              <div class="inner border_none">
                <h2>
                  <router-link
                    :to="{
                      name: 'tickets',
                      query: { filter_status: 'unresolved', period: 16 },
                    }"
                    >{{ statistic.unresolved ?? 0 }}</router-link
                  >
                </h2>
                <p class="color_green">
                  <router-link
                    :to="{
                      name: 'tickets',
                      query: { filter_status: 'unresolved', period: 16 },
                    }"
                    >View tickets</router-link
                  >
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col_4">
        <div class="card vlan-home-mini-stats mt_0">
          <div class="card_heading">
            <span class="mr_5">
              <svg
                width="22px"
                height="22px"
                viewBox="0 0 100 100"
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                fill="#000000"
              >
                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                <g
                  id="SVGRepo_tracerCarrier"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></g>
                <g id="SVGRepo_iconCarrier">
                  <rect
                    x="18"
                    width="64"
                    y="10"
                    height="80"
                    style="fill: #aaaaaa; stroke-width: 5; stroke: #222222"
                  ></rect>
                  <rect
                    x="25"
                    width="50"
                    y="20"
                    height="60"
                    style="fill: #ebebda; stroke-width: 2; stroke: black"
                  ></rect>
                  <line
                    x1="35"
                    y1="30"
                    x2="65"
                    y2="30"
                    style="stroke-width: 2; stroke: black"
                  ></line>
                  <line
                    x1="35"
                    y1="40"
                    x2="65"
                    y2="40"
                    style="stroke-width: 2; stroke: black"
                  ></line>
                  <line
                    x1="35"
                    y1="50"
                    x2="65"
                    y2="50"
                    style="stroke-width: 2; stroke: black"
                  ></line>
                  <polygon
                    points="40 7, 60 7, 65 20, 35 20, 40 7"
                    style="fill: black; fill-opacity: 1; stroke: none"
                  ></polygon>
                  <defs>
                    <mask id="mask_circle">
                      <circle cx="50" cy="50" r="50" fill="white"></circle>
                      <circle cx="50" cy="50" r="12" fill="#000000"></circle>
                    </mask>
                    <linearGradient
                      x1="20"
                      y1="60"
                      x2="60"
                      y2="40"
                      id="Gradient"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop
                        style="stop-color: #650e13; stop-opacity: 1"
                        offset="0"
                      ></stop>
                      <stop
                        style="stop-color: #dd3043; stop-opacity: 1"
                        offset="1"
                      ></stop>
                    </linearGradient>
                  </defs>
                  <g transform="scale(0.6), translate(56,56)">
                    <circle
                      cx="50"
                      cy="50"
                      r="48"
                      style="fill: #650e13"
                    ></circle>
                    <circle
                      cx="50"
                      cy="50"
                      r="43"
                      style="
                        fill: url(#Gradient);
                        stroke: #eeeeee;
                        stroke-width: 3;
                      "
                    ></circle>
                    <path
                      style="fill: #ffffff"
                      d="m 19,42 0,17 61,0 0,-17 z"
                    ></path>
                  </g>
                </g>
              </svg>
            </span>
            Overdue
          </div>
          <div class="card_body">
            <div class="mini-stats-content">
              <div class="inner border_none">
                <h2>
                  <router-link
                    :to="{
                      name: 'tickets',
                      query: { filter_status: 'overdue', period: 16 },
                    }"
                    >{{ statistic.overdue ?? 0 }}</router-link
                  >
                </h2>
                <p class="color_green">
                  <router-link
                    :to="{
                      name: 'tickets',
                      query: { filter_status: 'overdue', period: 16 },
                    }"
                    >View tickets</router-link
                  >
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col_4">
        <div class="card vlan-home-mini-stats mt_0">
          <div class="card_heading">
            <span class="mr_5">
              <svg
                width="22px"
                height="22px"
                viewBox="0 0 16 16"
                xmlns="http://www.w3.org/2000/svg"
                fill="#000000"
              >
                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                <g
                  id="SVGRepo_tracerCarrier"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></g>
                <g id="SVGRepo_iconCarrier">
                  <path
                    color="#000000"
                    d="M7.992 0A2.008 2.008 0 0 0 6 2H5c-.657 0-1.178.06-1.617.225-.439.164-.79.461-.998.838-.415.752-.37 1.673-.385 2.931v5.012c.015 1.258-.03 2.179.385 2.932.208.376.56.673.998.838.439.164.96.224 1.617.224h3.133c.021-.05.031-.102.059-.15l.482-.85H5c-.592 0-1.006-.063-1.265-.16-.26-.098-.372-.203-.473-.387C3.06 13.087 3.015 12.259 3 11V6c.015-1.259.06-2.087.262-2.453.101-.184.213-.29.473-.387C3.995 3.062 4.408 3 5 3v.999h6V3c.593 0 1.006.063 1.266.16.26.098.371.203.472.387.202.366.247 1.194.262 2.453v2.832c.31.115.582.323.752.62v.001l.248.438V5.994c-.015-1.258.031-2.179-.385-2.932a1.88 1.88 0 0 0-.998-.837C12.179 2.06 11.657 2 11 2H9.996a2.008 2.008 0 0 0-1.992-2zm.01 1c.559 0 1 .442 1 1a.99.99 0 0 1-1 1 .982.982 0 0 1-.922-.61A1.01 1.01 0 0 1 7.003 2c0-.558.441-1 1-1zM5 6v1h6.012V6zm0 2v1h6.012V8zm-.01 2v1h3v-1z"
                    fill="gray"
                    font-family="sans-serif"
                    font-weight="400"
                    overflow="visible"
                    style="
                      line-height: normal;
                      text-indent: 0;
                      text-align: start;
                      text-decoration-line: none;
                      text-decoration-style: solid;
                      text-decoration-color: #000000;
                      text-transform: none;
                      isolation: auto;
                      mix-blend-mode: normal;
                      marker: none;
                    "
                    white-space="normal"
                  ></path>
                  <path
                    class="warning"
                    color="#000000"
                    d="M12.48 9.729a.443.443 0 0 0-.36.22l-3.061 5.397a.437.437 0 0 0 .379.654h6.125a.437.437 0 0 0 .379-.654l-3.059-5.397a.442.442 0 0 0-.402-.22zM12 11h1v.168c0 .348-.016.667-.047.957-.03.29-.069.581-.115.875h-.666a12.898 12.898 0 0 1-.125-.875 9.146 9.146 0 0 1-.047-.957zm.5 3a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1z"
                    fill="#fdc92b"
                    fill-rule="evenodd"
                    font-family="sans-serif"
                    font-weight="400"
                    overflow="visible"
                    style="
                      line-height: normal;
                      text-indent: 0;
                      text-align: start;
                      text-decoration-line: none;
                      text-decoration-style: solid;
                      text-decoration-color: #000000;
                      text-transform: none;
                      isolation: auto;
                      mix-blend-mode: normal;
                    "
                    white-space="normal"
                  ></path>
                </g>
              </svg>
            </span>
            Due today
          </div>
          <div class="card_body">
            <div class="mini-stats-content">
              <div class="inner border_none">
                <h2>
                  <router-link
                    :to="{
                      name: 'tickets',
                      query: { filter_status: 'due-today', period: 16 },
                    }"
                    >{{ statistic.due_today ?? 0 }}</router-link
                  >
                </h2>
                <p class="color_green">
                  <router-link
                    :to="{
                      name: 'tickets',
                      query: { filter_status: 'due-today', period: 16 },
                    }"
                    >View tickets</router-link
                  >
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col_4" v-if="user?.user_role == 'Admin'">
        <div class="card vlan-home-mini-stats">
          <div class="card_heading">
            <span class="mr_5">
              <svg
                fill="#000000"
                width="22px"
                height="22px"
                viewBox="0 0 100 100"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                <g
                  id="SVGRepo_tracerCarrier"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></g>
                <g id="SVGRepo_iconCarrier">
                  <path
                    d="M49.91,20A25.4,25.4,0,1,0,75.09,45.5C75.09,31.71,63.85,20,49.91,20ZM66.45,43.24,55.93,53.38c-.76.76-1.77.13-1.77-1.14V46.16c-7.6,0-12.67,5.19-12.67,12.8h-7.6a20.12,20.12,0,0,1,20.27-20.4V32.35c0-1.27,1.14-1.9,1.77-1.14L66.45,41.47A1.52,1.52,0,0,1,66.45,43.24Z"
                    fill-rule="evenodd"
                  ></path>
                  <path
                    d="M26,64.21H24.73A4.75,4.75,0,0,0,20,68.95v6.31A4.74,4.74,0,0,0,24.73,80H75.27A4.75,4.75,0,0,0,80,75.26V68.95a4.74,4.74,0,0,0-4.73-4.74H73.73a30.15,30.15,0,0,1-47.72,0Z"
                    fill-rule="evenodd"
                  ></path>
                </g>
              </svg>
            </span>
            Unassigned
          </div>
          <div class="card_body">
            <div class="mini-stats-content">
              <div class="inner border_none">
                <h2>
                  <router-link
                    :to="{
                      name: 'tickets',
                      query: { filter_status: 'unassigned', period: 16 },
                    }"
                    >{{ statistic.unassigned ?? 0 }}</router-link
                  >
                </h2>
                <p class="color_green">
                  <router-link
                    :to="{
                      name: 'tickets',
                      query: { filter_status: 'unassigned', period: 16 },
                    }"
                    >View tickets</router-link
                  >
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        :class="[
          { col_4: user?.user_role == 'Admin' },
          { col_6: user?.user_role != 'Admin' },
        ]"
      >
        <div class="card vlan-home-mini-stats">
          <div class="card_heading">
            <span class="mr_5">
              <svg
                fill="#000000"
                width="22px"
                height="22px"
                viewBox="0 0 512 512"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                <g
                  id="SVGRepo_tracerCarrier"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></g>
                <g id="SVGRepo_iconCarrier">
                  <g fill-rule="evenodd" transform="translate(42.667 42.667)">
                    <path
                      d="M178.0832,42.6666667 L221.594,77.0716667 L191.217,107.448667 L163.24992,85.3333333 L42.6666667,85.3333333 L42.6666667,296.106667 L82.0209067,170.666667 L341.333333,170.666667 L341.333,170.665667 L384,170.665667 L437.333333,170.666667 L372.583253,384 L-2.13162821e-14,384 L-2.13162821e-14,42.6666667 L178.0832,42.6666667 Z M379.79136,213.333333 L113.354027,213.333333 L73.1874133,341.333333 L340.95808,341.333333 L379.79136,213.333333 Z"
                    ></path>
                    <path
                      fill-rule="nonzero"
                      d="M384,7.10542736e-15 L384,149.333333 L341.333333,149.333333 L341.332777,72.836 L264.836777,149.332777 L204.496777,149.333333 L311.162777,42.666 L234.666667,42.6666667 L234.666667,7.10542736e-15 L384,7.10542736e-15 Z"
                    ></path>
                  </g>
                </g>
              </svg>
            </span>
            Open
          </div>
          <div class="card_body">
            <div class="mini-stats-content">
              <div class="inner border_none">
                <h2>
                  <router-link
                    :to="{
                      name: 'tickets',
                      query: { filter_status: 'open', period: 16 },
                    }"
                    >{{ statistic.open ?? 0 }}</router-link
                  >
                </h2>
                <p class="color_green">
                  <router-link
                    :to="{
                      name: 'tickets',
                      query: { filter_status: 'open', period: 16 },
                    }"
                    >View tickets</router-link
                  >
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        :class="[
          { col_4: user?.user_role == 'Admin' },
          { col_6: user?.user_role != 'Admin' },
        ]"
      >
        <div class="card vlan-home-mini-stats">
          <div class="card_heading">
            <span class="mr_5">
              <svg
                fill="#000000"
                width="22px"
                height="22px"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                <g
                  id="SVGRepo_tracerCarrier"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></g>
                <g id="SVGRepo_iconCarrier">
                  <path
                    d="M20,5a2.984,2.984,0,0,0-1.116.22A2.961,2.961,0,0,0,14.529,3.4a2.983,2.983,0,0,0-5.058,0A2.967,2.967,0,0,0,8,3,3,3,0,0,0,5,6V7.1A5.009,5.009,0,0,0,1,12v1a9.01,9.01,0,0,0,9,9h4a9.01,9.01,0,0,0,9-9V8A3,3,0,0,0,20,5Zm1,8a7.009,7.009,0,0,1-7,7H10a7.009,7.009,0,0,1-7-7V12A3.006,3.006,0,0,1,5,9.171V10a1,1,0,0,0,2,0V6A1,1,0,0,1,9,6V9a1,1,0,0,0,2,0V5a1,1,0,0,1,2,0V9a1,1,0,0,0,2,0V6a1,1,0,0,1,2,0V9a1,1,0,0,0,2,0V8a1,1,0,0,1,2,0Z"
                  ></path>
                </g>
              </svg>
            </span>
            Closed
          </div>
          <div class="card_body">
            <div class="mini-stats-content">
              <div class="inner border_none">
                <h2>
                  <router-link
                    :to="{
                      name: 'tickets',
                      query: { filter_status: 'closed', period: 16 },
                    }"
                    >{{ statistic.closed ?? 0 }}</router-link
                  >
                </h2>
                <p class="color_green">
                  <router-link
                    :to="{
                      name: 'tickets',
                      query: { filter_status: 'closed', period: 16 },
                    }"
                    >View tickets</router-link
                  >
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row mb_20">
      <ActivityLogComponent
        title="Recent activities"
        :activities="recentActivities"
      />
      <ActivityLogComponent
        title="Last Month activities"
        :activities="lastMonthActivities"
      />
    </div>
    <div class="row mb_20 mt_10">
      <div class="col_4">
        <div class="card vlan_home_email_trackers">
          <div class="card_heading">
            <div class="fw_600">Undelivered emails</div>
          </div>
          <div class="card_body">
            <div class="">
              <div class="table_responsive">
                <table class="table">
                  <tbody>
                    <tr
                      v-for="email in undeliveredEmails"
                      :key="'email_' + email.id"
                    >
                      <td>
                        <span class="fw_500"> {{ email.mail_to }}</span>
                      </td>
                      <td class="text_right">
                        <button
                          type="button"
                          class="btn btn_sm has_border_radius_15 btn_black pl_15 pr_15"
                        >
                          {{ email.undelivered_count }}
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <TodosComponent />
      <div class="col_4">
        <div class="card vlan_home_email_trackers">
          <div class="card_heading">
            <div class="fw_600">Unresolved tickets</div>
          </div>
          <div class="card_body">
            <div class="">
              <div class="table_responsive">
                <table class="table">
                  <tbody>
                    <tr
                      v-for="ticket in groupTickets"
                      :key="'group_' + ticket.id"
                    >
                      <td>
                        <span class="fw_500">
                          <router-link
                            :to="{
                              name: 'tickets',
                              query: {
                                filter_status: 'unresolved',
                                group_id: ticket.group_id,
                              },
                            }"
                            >{{ ticket?.group?.name }}</router-link
                          ></span
                        >
                      </td>
                      <td class="text_right">
                        <router-link
                          :to="{
                            name: 'tickets',
                            query: {
                              filter_status: 'unresolved',
                              group_id: ticket.group_id,
                            },
                          }"
                        >
                          <button
                            type="button"
                            class="btn btn_sm has_border_radius_15 btn_black pl_15 pr_15"
                          >
                            {{ ticket.ticket_count }}
                          </button>
                        </router-link>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col_12 mb_20 mt_10">
        <shift-dashboard-calender
          v-if="user.user_role == 'Admin'"
          :shifts="shifts"
        />
        <working-shift-calendar
          v-else
          :showTable="false"
          :viewLink="true"
          :shifts="shifts"
        />
      </div>
      <div class="col_6 mb_20 mt_10">
        <ScheduleCalender v-if="user.user_role == 'Admin'" />
        <EmployeeScheduleCalender v-else />
      </div>
      <div class="col_6 mb_20 mt_10">
        <LeaveCalender v-if="user.user_role == 'Admin'" />
        <EmployeeLeaveCalender v-else />
      </div>
    </div>
  </div>
</template>

<script>
import ActivityLogComponent from '@/components/shared/dashboard/ActivityLogComponent.vue';
import TodosComponent from '@/components/shared/dashboard/TodosComponent.vue';
import { mapGetters } from 'vuex';
import LeaveCalender from './LeaveCalender.vue';
import EmployeeLeaveCalender from './EmployeeLeaveCalender.vue';
import ScheduleCalender from './ScheduleCalender.vue';
import EmployeeScheduleCalender from './EmployeeScheduleCalender.vue';
import ShiftDashboardCalender from './ShiftDashboardCalender.vue';
import WorkingShiftCalendar from './shifts/WorkingShiftCalendar.vue';

export default {
  name: 'dashboard',
  components: {
    TodosComponent,
    ActivityLogComponent,
    LeaveCalender,
    EmployeeLeaveCalender,
    ScheduleCalender,
    EmployeeScheduleCalender,
    ShiftDashboardCalender,
    WorkingShiftCalendar,
  },
  data() {
    return {
      statistic: {},
      recentActivities: [],
      lastMonthActivities: [],
      undeliveredEmails: [],
      groupTickets: [],
      shifts: [],
    };
  },
  created() {
    this.getDashboardStatistics();
    this.getRecentActivities();
    this.getLastMonthActivities();
    this.getUndeliveredEmails();
    this.getUnresolvedTickets();
    this.getShifts();
  },
  computed: {
    ...mapGetters({
      user: 'auth/getUser',
    }),
  },
  mounted() {},
  methods: {
    getShifts() {
      this.axios.get('/active-shifts-for-relation').then(({ data }) => {
        this.shifts = data.data;
      });
    },
    getDashboardStatistics() {
      this.axios.get('/statistics').then(({ data }) => {
        this.statistic = data;
      });
    },
    getRecentActivities() {
      this.axios.get('/recent-activities').then(({ data }) => {
        this.recentActivities = data.data;
      });
    },
    getLastMonthActivities() {
      this.axios.get('/last-month-recent-activities').then(({ data }) => {
        this.lastMonthActivities = data.data;
      });
    },
    getUndeliveredEmails() {
      this.axios.get('/undelivered-emails').then(({ data }) => {
        this.undeliveredEmails = data.data;
      });
    },
    getUnresolvedTickets() {
      this.axios.get('/unresolved-tickets').then(({ data }) => {
        this.groupTickets = data;
      });
    },
  },
};
</script>

<style scoped>
.live_product_list .text h2 {
  text-align: center;
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.item_image {
  width: 50px;
}
.text_right {
  text-align: right;
}
.color_blue {
  color: #3c74e7 !important;
}
.color_green {
  text-decoration: underline;
  color: green !important;
}
</style>
